import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=7544724f&scoped=true"
import script from "./appointment.vue?vue&type=script&lang=js"
export * from "./appointment.vue?vue&type=script&lang=js"
import style0 from "./appointment.vue?vue&type=style&index=0&id=7544724f&prod&lang=less&scoped=true"
import style1 from "./appointment.vue?vue&type=style&index=1&id=7544724f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7544724f",
  null
  
)

export default component.exports